import React, { useEffect, useState } from 'react';
import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
import Restricted from '../CommonComponents/Restricted';
import { getPermittedUsers } from '../Services/ApiServices/userServices';
import { Cookies } from 'react-cookie-consent';

const MsaPrivateRoute = ({ children }) => {
    const [allowedUsers, setAllowedUsers] = useState()
    const { accounts } = useMsal();
    const user = accounts[0]?.username;

    useEffect(() => {
        const getUsers = async () => {
            await getPermittedUsers((res) => {
                setAllowedUsers(res.data.users);
            }, (err) => {
                console.log(err);
                localStorage.clear();

            })
        };
        if(accounts.length > 0){   
            Cookies.set('ar_user_Id', accounts[0].username)
            // Cookies.set('ar_user_email', accounts[0].username)
            if (process.env.REACT_APP_APPLICATION_VERSION === "Microsoft") {
                return true;
            } {
                getUsers();
            }
          } 
    }, [])
    
    if (allowedUsers && allowedUsers.includes(user.toLowerCase())) {
        return <AuthenticatedTemplate>{children}</AuthenticatedTemplate>;
    } else if(allowedUsers && !allowedUsers.includes(user.toLowerCase())) {
        return <Restricted/>;
    } else {
        return <AuthenticatedTemplate>{children}</AuthenticatedTemplate>;
    }
};

export default MsaPrivateRoute;
